import { IImage, TEmptyScreen } from "./common";

export enum EntitiesComponent {
  VacancyPlatformInfo = "entities.vacancy-platform-info",
  VacancySalaryInfo = "entities.vacancy-salary-info",
  VacancyCard = "entities.vacancy-card",
  IndexPageMeta = "entities.index-page-meta",
  CompanyDetailPageMeta = "entities.company-detail-page-meta",
  DomesticVacancyDetailPageMeta = "entities.domestic-vacancy-detail-page-meta",
}

export type TVacancyPlatformInfo = {
  id: number;
  label: string;
  defaultPlatformLogo: IImage;
  defaultPlatformLabel: string;
  __component: EntitiesComponent.VacancyPlatformInfo;
}

export type TVacancySalaryInfo = {
  id: number;
  hideLabel: string;
  __component: EntitiesComponent.VacancySalaryInfo;
}

export type TVacancyCard = {
  id: number;
  salaryLabel: string;
  salaryInfo: TVacancySalaryInfo;
  platformInfo: TVacancyPlatformInfo;
  __component: EntitiesComponent.VacancyCard;
}

export type TFaq = {
  id: number;
  question: string;
  answer: string;
}

export type TIndexPageMeta = {
  id: number;
  title: string;
  emptyScreen: TEmptyScreen;
  __component: EntitiesComponent.IndexPageMeta;
}

export type TCompanyDetailPageMeta = {
  id: number;
  registerSinceLabel: string;
  phoneLabel: string;
  emailLabel: string;
  websiteLabel: string;
  addressLabel: string;
  vacancyLabel: string;
  vacancyEmptyScreen: TEmptyScreen;
  __component: EntitiesComponent.CompanyDetailPageMeta;
}

export type TDomesticVacancyDetailPageMeta = {
  id: number;
  publishedAtLabel: string;
  availableQuotaLabel: string;
  expiresAtLabel: string;
  applyButtonLabel: string;
  jobFunctionLabel: string;
  jobTypeLabel: string;
  vacancyableTypeLabel: string;
  genderLabel: string;
  salaryLabel: string;
  jobDescriptionLabel: string;
  specialRequirementsLabel: string;
  generalRequirementsLabel: string;
  educationLabel: string;
  maritalStatusLabel: string;
  minExperienceLabel: string;
  physicalConditionLabel: string;
  skillsLabel: string;
  companyLinkLabel: string;
  companyAboutLabel: string;
  proposalStatusLabel: string;
  proposalLinkLabel: string;
  coverBackground: IImage;
  salaryInfo: TVacancySalaryInfo;
  __component: EntitiesComponent.DomesticVacancyDetailPageMeta;
}